import PropTypes from "prop-types";
import AnimatedPopup from "../../components/AnimatedComponents/AnimatedPopup";
import styles from "./LoginFailurePopup.module.scss";

const LoginFailurePopup = ({ show, title = "Login failure", message, onClose }) => {
  return (
    <AnimatedPopup show={show}>
      <div role="dialog" aria-modal={true} aria-label={title} className={styles.overlay}>
        <div className={styles.card}>
          <h3 className={styles.title}>{title}</h3>
          <p className={styles.message}>{message}</p>
          <button onClick={onClose} className={styles.button}>
            Back
          </button>
        </div>
      </div>
    </AnimatedPopup>
  );
};

LoginFailurePopup.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default LoginFailurePopup;
